// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/poppins-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/poppins-medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/poppins-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/poppins-semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/poppins-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/poppins-bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/poppins-bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oswald&family=PT+Sans+Narrow&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Poppins Regular */
@font-face {
  font-family: "poppinsregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: normal; /* Regular */
  font-style: normal;
}

/* Poppins Medium */
@font-face {
  font-family: "poppinsmedium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: normal; /* SemiBold */
  font-style: normal;
}

/* Poppins SemiBold */
@font-face {
  font-family: "poppinssemibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: normal; /* SemiBold */
  font-style: normal;
}

/* Poppins Bold */
@font-face {
  font-family: "poppinsbold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff");
  font-weight: normal; /* Bold */
  font-style: normal;
}

html body {
  font-family: "poppinsregular", sans-serif !important;
  font-weight: 400 !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  overflow-x: hidden !important;
  background: #fff !important;
}

#launcher-frame {
  left : -97px !important;
  
}

* {
  font-family: "poppinsregular", sans-serif !important;
}

:where(.css-dev-only-do-not-override-15rg2km)[class^="ant-layout"],
:where(.css-dev-only-do-not-override-15rg2km)[class*=" ant-layout"] {
  font-family: "poppinsregular", sans-serif !important;
}

.header {
  background: #fff;
}

.photo-viewer-container {
  width: 691px !important;
  height: 450px !important;
}

.photo {
  width: 380px !important;
  height: 450px !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  height: 8px; /* Adjust the height as needed */
  width: 10px;
  background-color: white;
}

/* Scrollbar thumb */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: grey;
}
.ant-input-affix-wrapper-disabled .ant-input[disabled]{
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B;0DACqD;EACrD,mBAAmB,EAAE,YAAY;EACjC,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;EAC5B;0DACmD;EACnD,mBAAmB,EAAE,aAAa;EAClC,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,8BAA8B;EAC9B;0DACqD;EACrD,mBAAmB,EAAE,aAAa;EAClC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B;0DACiD;EACjD,mBAAmB,EAAE,SAAS;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;;AAEzB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,WAAW,EAAE,gCAAgC;EAC7C,WAAW;EACX,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;AACd","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Oswald&family=PT+Sans+Narrow&display=swap\");\n\n/* Poppins Regular */\n@font-face {\n  font-family: \"poppinsregular\";\n  src: url(\"./fonts/poppins-regular.woff2\") format(\"woff2\"),\n    url(\"./fonts/poppins-regular.woff2\") format(\"woff\");\n  font-weight: normal; /* Regular */\n  font-style: normal;\n}\n\n/* Poppins Medium */\n@font-face {\n  font-family: \"poppinsmedium\";\n  src: url(\"./fonts/poppins-medium.woff2\") format(\"woff2\"),\n    url(\"./fonts/poppins-medium.woff\") format(\"woff\");\n  font-weight: normal; /* SemiBold */\n  font-style: normal;\n}\n\n/* Poppins SemiBold */\n@font-face {\n  font-family: \"poppinssemibold\";\n  src: url(\"./fonts/poppins-semibold.woff2\") format(\"woff2\"),\n    url(\"./fonts/poppins-semibold.woff\") format(\"woff\");\n  font-weight: normal; /* SemiBold */\n  font-style: normal;\n}\n\n/* Poppins Bold */\n@font-face {\n  font-family: \"poppinsbold\";\n  src: url(\"./fonts/poppins-bold.woff2\") format(\"woff2\"),\n    url(\"./fonts/poppins-bold.woff\") format(\"woff\");\n  font-weight: normal; /* Bold */\n  font-style: normal;\n}\n\nhtml body {\n  font-family: \"poppinsregular\", sans-serif !important;\n  font-weight: 400 !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow: hidden;\n  overflow-x: hidden !important;\n  background: #fff !important;\n}\n\n#launcher-frame {\n  left : -97px !important;\n  \n}\n\n* {\n  font-family: \"poppinsregular\", sans-serif !important;\n}\n\n:where(.css-dev-only-do-not-override-15rg2km)[class^=\"ant-layout\"],\n:where(.css-dev-only-do-not-override-15rg2km)[class*=\" ant-layout\"] {\n  font-family: \"poppinsregular\", sans-serif !important;\n}\n\n.header {\n  background: #fff;\n}\n\n.photo-viewer-container {\n  width: 691px !important;\n  height: 450px !important;\n}\n\n.photo {\n  width: 380px !important;\n  height: 450px !important;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  height: 8px; /* Adjust the height as needed */\n  width: 10px;\n  background-color: white;\n}\n\n/* Scrollbar thumb */\n::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: grey;\n}\n.ant-input-affix-wrapper-disabled .ant-input[disabled]{\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
